import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';

import { useAppSelector } from 'shared/hooks';

import Item from './Item';

import './Table.scss';

const b = block('statistic-table-desktop');

const Table = ({ data, type }) => {
  const locale = useAppSelector(state => state.locale.locale, shallowEqual);

  const itemsElements = useMemo(
    () =>
      data?.map((t, i) => (
        <div key={t.number} className={b('item')}>
          <Item item={t} type={type} />
        </div>
      )),
    [data, type],
  );

  const headerClass = type === 'players' ? b('header', { 'six-columns': true }) : b('header', { 'four-columns': true });

  return (
    <div className={b()}>
      <div className={headerClass}>
        <div className={b('header-item')}>{locale.number}</div>
        <div className={b('header-item')}>{locale.id}</div>
        <div className={b('header-item')}>{locale.username}</div>
        {type === 'players' && (
          <>
            <div className={b('header-item')}>{locale.bets}</div>
            <div className={b('header-item')}>{locale.wins}</div>
          </>
        )}
        <div className={b('header-item')}>{locale.netwin}</div>
      </div>
      {itemsElements?.length ? itemsElements : <div className={b('empty')}>{locale.noResultsFound}</div>}
    </div>
  );
};

export default Table;
